import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SPHERES, TAX_CODES } from './types';

export const useTaxCodeOptions = () => {
    const { t } = useTranslation('invoice');

    return useMemo(
        () => [
            { key: '', label: t('account.form.none') },
            ...TAX_CODES.map((code) => ({ key: code, label: t(`taxCodes.${code}`) }))
        ],
        [t]
    );
};

export const useSphereOptions = () => {
    const { t } = useTranslation('invoice');

    return useMemo(
        () => [
            { key: '', label: t('account.form.none') },
            ...SPHERES.map((sphere) => ({ key: sphere, label: `${t(`spheres.${sphere}.label`)} (${t(`spheres.${sphere}.hint`)})` }))
        ],
        [t]
    );
};
